import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface EditWorkOrderModalState {
  isEditWorkOrderModalOpened: boolean;
}

interface ToggleViewPayload {
  isEditWorkOrderModalOpened: boolean;
}

export const initialState: EditWorkOrderModalState = {
  isEditWorkOrderModalOpened: false
};

const editWorkOrderModalSlice = createSlice({
  name: 'editModal',
  initialState,
  reducers: {
    toggleEditModalView(state, action: PayloadAction<ToggleViewPayload>) {
      state.isEditWorkOrderModalOpened = action.payload.isEditWorkOrderModalOpened;
    }
  }
});

export const {
  toggleEditModalView
} = editWorkOrderModalSlice.actions;

export default editWorkOrderModalSlice.reducer;
